import { settings } from 'config';
import { getItemFromStore, setItemToStore } from 'helpers/utils';

const configState = () => ({
 isFluid: getItemFromStore('isFluid', settings.isFluid),
 isRTL: getItemFromStore('isRTL', settings.isRTL),
 isDark: getItemFromStore('isDark', settings.isDark),
 navbarPosition: getItemFromStore('navbarPosition', settings.navbarPosition),
 disabledNavbarPosition: [],
 isNavbarVerticalCollapsed: getItemFromStore('isNavbarVerticalCollapsed', settings.isNavbarVerticalCollapsed),
 navbarStyle: getItemFromStore('navbarStyle', settings.navbarStyle)
});

export const configReducer = (state, action) => {
 const { type, payload } = action;
 switch (type) {
  case 'SET_CONFIG':
   if (payload.setInStore) {
    setItemToStore(payload.key, payload.value);
   }
   return { ...state, [payload.key]: payload.value };
  case 'REFRESH':
   return { ...state, ...configState() };
  case 'RESTORE':
   if (payload?.tem) return { ...state, ...payload };
   Object.entries(payload).map(
    e =>
     ['isFluid', 'isRTL', 'navbarPosition', 'isNavbarVerticalCollapsed', 'navbarStyle'].includes(e[0]) &&
     setItemToStore(e[0], e[1])
   );
   return { ...state, ...payload };
  case 'RESET':
   localStorage.clear();
   return { ...state, ...settings };
  default:
   return state;
 }
};
